import React from 'react';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';

export default class CommentInput extends Component {
  render() {
    const displayName = 'comment';
    const { placeholder } = this.props;
    return (
      <div
        style={this.style()}
        className={this.className(bem(displayName, 'input'))}
        {...getDataAttr(this.props)}>
        <input type="text" disabled placeholder={placeholder} value="" />
      </div>
    );
  }
}

CommentInput.defaultProps = {
  placeholder: '自古评论出人才，快来说两句',
};

CommentInput.propTypes = {
  // @INTRO placeholder
  placeholder: PropTypes.string,
};
